import React from "react";

export default function ProductionReport() {
  return (
    <div className="erp-page-grid">
      <h2>Production Report</h2>

      <div className="erp-card">
        <p>This is a simple production report page.</p>
      </div>
    </div>
  );
}